import { energyTypes } from '../data/energyTypes';

const isZeroOrFive = (digit) => digit === 0 || digit === 5;

export function calculateEnergyPairs(phoneNumber) {
  if (!phoneNumber || phoneNumber.length !== 10) return [];

  const digits = phoneNumber.split('').map(Number);
  const results = [];
  let lastEnergyResult = null;

  for (let pos = 1; pos < digits.length - 1;) {
    let currentPair = '';
    let energyName = '';
    let originalEnergy = '';
    let position = '';
    let number = '';

    if (!isZeroOrFive(digits[pos + 1])) {
      currentPair = `${digits[pos]}${digits[pos + 1]}`;
      energyName = energyTypes[currentPair] || 'Không xác định';
      originalEnergy = energyName;
      position = `${pos + 1}-${pos + 2}`;
      number = currentPair;
      lastEnergyResult = { pair: currentPair, energy: energyName, originalEnergy, position, number };
      results.push(lastEnergyResult);
      pos += 1;
      continue;
    }

    let j = pos + 2;
    let foundNextNumber = false;
    let middleDigits = '';

    while (j < digits.length) {
      if (!isZeroOrFive(digits[j])) {
        middleDigits = digits.slice(pos + 1, j).join('');
        currentPair = `${digits[pos]}${digits[j]}`;
        
        if (middleDigits.includes('0') || middleDigits.includes('5')) {
          energyName = `${energyTypes[currentPair] || 'Không xác định'} kẹp ${middleDigits.includes('0') ? '0' : '5'}`;
        } else {
          energyName = energyTypes[currentPair] || 'Không xác định';
        }
        
        originalEnergy = energyTypes[currentPair] || 'Không xác định';
        position = `${pos + 1}-${j + 1}`;
        number = `${digits[pos]}${middleDigits}${digits[j]}`;
        lastEnergyResult = { pair: number, energy: energyName, originalEnergy, position, number };
        results.push(lastEnergyResult);
        pos = j;
        foundNextNumber = true;
        break;
      }
      j++;
    }

    if (!foundNextNumber) {
      if (lastEnergyResult) {
        const remainingDigits = digits.slice(pos).join('');
        if (remainingDigits.length > 0) {
          results.pop();
          
          const startPos = parseInt(lastEnergyResult.position.split('-')[0]);
          const fullNumber = digits.slice(startPos - 1).join('');
          const hasZero = fullNumber.includes('0');
          
          results.push({
            position: `${startPos}-${digits.length}`,
            number: fullNumber,
            energy: `${lastEnergyResult.originalEnergy} ${hasZero ? '+0' : '+5'}`,
            originalEnergy: lastEnergyResult.originalEnergy,
          });
        }
      }
      break;
    }
  }
  
  return results;
}
